export default __webpack_public_path__ + "static/media/bm-retur-beli.956e50c6.png";